import { render, staticRenderFns } from "./ModalImageCaptureDelete.vue?vue&type=template&id=70751125&"
import script from "./ModalImageCaptureDelete.vue?vue&type=script&lang=js&"
export * from "./ModalImageCaptureDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports